//system
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, HttpServiceConfig } from './common/http.service';

//services
import { LogService } from './common/log.service';

//models
import { InterestedPerson } from '../models/common-models';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class InterestedPersonService {

  constructor(private logService: LogService
    , private httpService: HttpService
    , private _environmentService: EnvironmentService
  ) { 
    const config: HttpServiceConfig = {
      baseUrl: `${this._environmentService.getFacilityConfig().facilityUrl}api/v${this._environmentService.getFacilityConfig().facilityApiVersion}`
    };
    this.httpService.configure(config);
  }

  saveInterestedPerson(request: Partial<InterestedPerson>): Observable<InterestedPerson> {
    return this.httpService.post<InterestedPerson>(`InterestedPerson`, request);
  }

  getInterestedPerson(phone: string): Observable<InterestedPerson> {
    return this.httpService.get<InterestedPerson>(`InterestedPerson/ByPhone/${phone}`);
  }

  bookInterestedPerson(sessionId: number, interestedPersonId: number): Observable<InterestedPerson> {
    return this.httpService.post(`InterestedPerson/Book/${sessionId}/${interestedPersonId}`, {});
  }
}
